import {MatDialogRef} from '@angular/material/dialog';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {Department, ITeam} from '@signal/asp-data-commons';
import { TranslateService } from '@ngx-translate/core';


export interface TimeSlot {
  id: number;
  text: string;
}

@Component({
  selector: 'app-edit-capacity-override',
  templateUrl: './edit-capacity-override.component.html',
  styleUrls: ['./edit-capacity-override.component.scss']
})
export class EditCapacityOverrideComponent implements OnInit {

  editCapacity: UntypedFormGroup;
  displayColumns: string[];
  displayTotalColumns: string[];
  timeSlots: TimeSlot[] = [
    { id: 1, text: '10:00 AM' },
    { id: 2, text: '10:30 AM' },
    { id: 3, text: '11:00 AM' },
    { id: 4, text: '11:30 AM' },
    { id: 5, text: '12:00 PM' },
    { id: 6, text: '12:30 PM' },
    { id: 7, text: '1:00 PM' },
    { id: 8, text: '1:30 PM' },
    { id: 9, text: '2:00 PM' },
    { id: 10, text: '2:30 PM' }
  ];

  teams: ITeam[] = [
    { id: '1', department: Department.SERVICE, name: 'TEAM 1' },
    { id: '2', department: Department.SERVICE, name: 'TEAM 2' },
    { id: '3', department: Department.SERVICE, name: 'TEAM 3' },
    { id: '4', department: Department.SERVICE, name: 'TEAM 4' },
    { id: '5', department: Department.SERVICE, name: 'TEAM 5' },
    { id: '6', department: Department.SERVICE, name: 'TEAM 6' }
  ];

  constructor(public readonly dialogRef: MatDialogRef<EditCapacityOverrideComponent>,
              private readonly formBuilder: UntypedFormBuilder,
              private translate : TranslateService,) {
    this.editCapacity = this.formBuilder.group({
      capacityDetails: this.formBuilder.array([])
    });

    this.displayColumns = ['slot', ...this.teams.map(t => `${t.id}`)];
    this.displayTotalColumns = ['totalSlot', ...this.teams.map(t => `total${t.id}`)];

    this.timeSlots.forEach(option => {
      const capacityGroup = this.formBuilder.group({

      });
      (this.editCapacity.get('capacityDetails') as UntypedFormArray).push(this.formBuilder.control(false));
    });
  }

  ngOnInit() {
  }

  close() {
    this.dialogRef.close();
  }

  saveOverrideDetails() {
    this.dialogRef.close();
  }

}
